import { __awaiter, __generator } from "tslib";
import { backInStockActionsFactory } from './common/backInStockActionsFactory';
export var openBackInStockEmailModal = function (_a) {
    var context = _a.context, origin = _a.origin, isOnlineStoresViewerScript = _a.isOnlineStoresViewerScript;
    return function (_a) {
        var productId = _a.productId, variantId = _a.variantId;
        return __awaiter(void 0, void 0, void 0, function () {
            var backinStockActions;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, backInStockActionsFactory({
                            context: context,
                            origin: origin,
                            requireCompId: true,
                            isOnlineStoresViewerScript: isOnlineStoresViewerScript,
                        })];
                    case 1:
                        backinStockActions = _b.sent();
                        return [2 /*return*/, backinStockActions.openBackInStockEmailModal({
                                productId: productId,
                                variantId: variantId,
                            })];
                }
            });
        });
    };
};
//# sourceMappingURL=openBackInStockEmailModal.js.map